import { AbstractControl } from '@angular/forms';

export class LinksValidator {
    public static linkValidator(control: AbstractControl) {
        const linkValue = control.value;
        const isValid = LinksValidator.isLinkValueValid(linkValue);
        return !isValid ? { linkValue: false } : null;
    }

    public static isLinkValueValid(value: string) {
        return RegExp('(https?://)([\\da-z.-]+)').test(value);
    }
}
